import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

// Artsy (hand-drawn) layout
import { Nav as ArtsyNav } from "@/components/Nav";
import { Footer as ArtsyFooter } from "@/components/Footer";
import ArtsyHome from "@/pages/Home";
import ArtsyExperience from "@/pages/Experience";
import ArtsyProjects from "@/pages/Projects";
import ArtsyEducation from "@/pages/Education";
import ArtsyAbout from "@/pages/About";
import ArtsyContact from "@/pages/Contact";

// Professional layout
import { ProNav } from "@/components/ProNav";
import { ProFooter } from "@/components/ProFooter";
import ProHome from "@/pages/pro/Home";
import ProExperience from "@/pages/pro/Experience";
import ProProjects from "@/pages/pro/Projects";
import ProEducation from "@/pages/pro/Education";
import ProAbout from "@/pages/pro/About";
import ProContact from "@/pages/pro/Contact";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ArtsyLayout({ children }) {
  useEffect(() => {
    document.body.style.backgroundColor = "#F4F1EB";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  return (
    <div className="bg-sand min-h-screen font-sans text-ink">
      <div className="grain-overlay" aria-hidden="true" />
      <ArtsyNav />
      <main>{children}</main>
      <ArtsyFooter />
    </div>
  );
}

function ProLayout({ children }) {
  useEffect(() => {
    document.body.style.backgroundColor = "#FAFAFA";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);
  return (
    <div className="min-h-screen font-plex text-neutral-900" style={{ backgroundColor: "#FAFAFA" }}>
      <ProNav />
      <main>{children}</main>
      <ProFooter />
    </div>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Hand-drawn / artsy version */}
            <Route
              path="/handmade"
              element={
                <ArtsyLayout>
                  <ArtsyHome />
                </ArtsyLayout>
              }
            />
            <Route
              path="/handmade/experience"
              element={
                <ArtsyLayout>
                  <ArtsyExperience />
                </ArtsyLayout>
              }
            />
            <Route
              path="/handmade/projects"
              element={
                <ArtsyLayout>
                  <ArtsyProjects />
                </ArtsyLayout>
              }
            />
            <Route
              path="/handmade/education"
              element={
                <ArtsyLayout>
                  <ArtsyEducation />
                </ArtsyLayout>
              }
            />
            <Route
              path="/handmade/about"
              element={
                <ArtsyLayout>
                  <ArtsyAbout />
                </ArtsyLayout>
              }
            />
            <Route
              path="/handmade/contact"
              element={
                <ArtsyLayout>
                  <ArtsyContact />
                </ArtsyLayout>
              }
            />

            {/* Professional version at root */}
            <Route
              path="/"
              element={
                <ProLayout>
                  <ProHome />
                </ProLayout>
              }
            />
            <Route
              path="/experience"
              element={
                <ProLayout>
                  <ProExperience />
                </ProLayout>
              }
            />
            <Route
              path="/projects"
              element={
                <ProLayout>
                  <ProProjects />
                </ProLayout>
              }
            />
            <Route
              path="/education"
              element={
                <ProLayout>
                  <ProEducation />
                </ProLayout>
              }
            />
            <Route
              path="/about"
              element={
                <ProLayout>
                  <ProAbout />
                </ProLayout>
              }
            />
            <Route
              path="/contact"
              element={
                <ProLayout>
                  <ProContact />
                </ProLayout>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </ReactLenis>
  );
}

export default App;
